import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { isPickingColor } from 'utils';

export interface FrameSettingsPopoverProps {
  trigger: HTMLElement | null;
  onClose: () => void;
  className?: string;
  isColorPicker?: boolean;
}

export class FrameSettingsPopover extends React.Component<FrameSettingsPopoverProps> {
  componentDidMount() {
    this.reposition();
    window.addEventListener('mousedown', this.didClickOnWindow, true);
    window.addEventListener('stackScrolled', this.props.onClose);
  }

  reposition() {
    if (this.props.trigger) {
      const box = this.props.trigger.getBoundingClientRect();
      const me = ReactDOM.findDOMNode(this) as HTMLElement;
      const top = Math.min(
        box.top - 9,
        window.innerHeight - me.getBoundingClientRect().height
      );
      me.style.left = box.right + 'px';
      me.style.top = top + 'px';
    }
  }

  componentWillUnmount() {
    window.removeEventListener('mousedown', this.didClickOnWindow, true);
    window.removeEventListener('stackScrolled', this.props.onClose);
  }

  didClickOnWindow = (e: MouseEvent) => {
    const { onClose, isColorPicker } = this.props;
    if (isPickingColor() && isColorPicker !== true) {
      return;
    }
    const me = ReactDOM.findDOMNode(this) as Element;
    if (!me.contains(e.target as HTMLElement)) {
      onClose();
    }
  };

  componentDidUpdate() {
    if (!isPickingColor()) {
      // TODO: be more selective when reposition?
      this.reposition();
    }
  }

  render() {
    const { className, children } = this.props;
    return (
      <div className={`${className ?? ''} frame-settings-popover`}>
        {children}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/controller/settings-popovers/FrameSettingsPopover.tsx